import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { header } from "./ListNav.module.scss";

const ListNavHeader = ({ className, ...props }) => (
  <header className={classNames(header, className)} {...props} />
);

ListNavHeader.propTypes = {
  className: PropTypes.string
};

ListNavHeader.defaultProps = {
  className: ""
};

export default ListNavHeader;
